import { useTranslation } from 'react-i18next'

import { CheckIcon } from 'app/common/presentation/icons'

import styles from './ConnectionStepper.module.scss'

interface ConnectionStepperProps {
  activeStep: number
}

export const ConnectionStepper = ({ activeStep }: ConnectionStepperProps) => {
  const { t } = useTranslation('connections')
  const steps = [
    t('setup.signIn.steps.connect'),
    t('setup.signIn.steps.accounts'),
    t('setup.signIn.steps.verify'),
    t('setup.signIn.steps.ids'),
  ]

  return (
    <div className={styles.stepper}>
      {steps.map((step, index) => {
        const stepNumber = index + 1
        const state =
          stepNumber < activeStep ? 'complete' : stepNumber === activeStep ? 'active' : 'pending'

        return (
          <div className={styles.step} data-state={state} key={step}>
            <div className={styles.stepLine} />
            <div className={styles.stepContent}>
              <div className={styles.stepIndicator}>{state === 'complete' && <CheckIcon />}</div>
              <div className={styles.stepLabels}>
                <span>{t('setup.signIn.step', { number: stepNumber })}</span>
                <strong>{step}</strong>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
